export default __webpack_public_path__ + "static/media/ic_fav_blue_120_gradient.be91a845.svg";